import { graphql } from '@/gql';
import type { ValidatePartnerGeofenceMutation } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export { PartnerGeofenceTarget } from '@/gql/graphql';

export type ValidatePartnerGeofenceOutput = ValidatePartnerGeofenceMutation['validatePartnerGeofence'];

export const validatePartnerGeofence = async (content: string): Promise<ValidatePartnerGeofenceOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ValidatePartnerGeofence($content: String!) {
        validatePartnerGeofence(content: $content) {
          data
          centroid {
            lat
            lng
          }
          polygons {
            lat
            lng
          }
        }
      }
    `),
    variables: {
      content,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data!.validatePartnerGeofence;
};
